import type { DefaultIconProps } from '../../../utils';
import { DefaultIconWrapper, getSemanticTextColor } from '../../../utils';

export const PigIcon = ({
  width = 37,
  marginRight,
  marginLeft,
  color = 'foraBlue',
  containerSize,
}: DefaultIconProps) => (
  <DefaultIconWrapper marginLeft={marginLeft} marginRight={marginRight} containerSize={containerSize} width={width}>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 39">
      <path
        fill={getSemanticTextColor(color)}
        fillRule="evenodd"
        d="M5.137 12.808s5.454-.587 8.238 1.934c.417-.04 1.153-.094 1.631-.094.213 0 .417.015.626.025 6.593.263 11.937 4.708 12.454 10.311.333.597.965.9 1.914.9v1.258c-.825 0-1.437-.174-1.914-.433-.317 3.823-2.868 7.215-6.836 9.054V39h-3.749v-2.089c-.631.11-1.253.17-1.874.2-1.497.064-2.958-.09-4.375-.458v2.342H7.503v-3.888C5.246 33.76 3.535 31.84 2.62 29.632H0v-7.497h2.62c.915-2.202 2.67-4.156 4.928-5.499-.095-.67-.254-1.67-1.512-2.928zm2.123 7.14c-.746 0-1.353.606-1.353 1.352 0 .746.607 1.353 1.353 1.353.745 0 1.351-.607 1.351-1.353s-.606-1.353-1.351-1.353zm7.765-3.858c-1.224 0-2.405.157-3.515.45v1.01c1.102-.315 2.285-.486 3.515-.486 1.231 0 2.413.171 3.515.485V16.54c-1.109-.293-2.291-.45-3.515-.45zm0-10.164c1.945-.005 3.515 1.571 3.515 3.515 0 1.944-1.576 3.515-3.515 3.515-1.944 0-3.515-1.576-3.515-3.515 0-1.944 1.576-3.515 3.515-3.515zM21.618 0c1.944 0 3.515 1.576 3.515 3.515 0 1.944-1.576 3.515-3.515 3.515-1.944 0-3.515-1.576-3.515-3.515C18.103 1.571 19.679 0 21.618 0z"
      />
    </svg>
  </DefaultIconWrapper>
);
